import { Business } from '@40seas/entities/businesses';
import { ViewMode } from '@40seas/entities/common';
import { UserRole } from '@40seas/entities/users';
import { DisplayOrganization, DisplayTenant } from '@40seas/frontend/libs/entities';
import * as React from 'react';

export type AppStore = {
    organization: DisplayOrganization;
    isProductionEnv: boolean;
    isTestMode: boolean;
    basename: string;
    urlRole: UserRole | null;
    viewMode: ViewMode;
    business?: { id: string } | Business;
    tenant?: string;
    setOrganization: (organization: DisplayOrganization, resource?: string, tenant?: string, shouldNavigate?: boolean) => Promise<void>;
    setTenant: (tenant: DisplayTenant) => void;
    setLogo: (logo: string) => void;
};

export const AppStoreContext = React.createContext<AppStore>({
    organization: {
        id: '',
        name: '',
        displayName: '',
        tenants: [],
    },
    isProductionEnv: false,
    isTestMode: false,
    basename: '',
    urlRole: null,
    viewMode: ViewMode.Supplier,
    setOrganization: async () => {},
    setTenant: () => {},
    setLogo: () => {},
});

export const useAppStore = (): AppStore => React.useContext(AppStoreContext);
